import styled from 'styled-components';
const percentageSize = 1.3;
export const FavCardWrapper = styled.div`
  min-height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  background-color: #333333;
  border-radius: 5px;
  font-size: 14px;
`;

export const FavTextWrapper = styled.div`
  overflow-x: hidden;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: white;
`;
export const FavLayerText = styled.div`
  overflow-x: hidden;
  white-space: nowrap;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;

  text-overflow: ellipsis;
  color: white;
`;
export const FavButtonsWrapper = styled.div`
  display: flex;
`;

export const FavTextEditInput = styled.input`
  background: transparent;
  border: none;
  padding: 0;
  border-bottom: 1px solid white;
  color: white;
  width: 100%;
  margin-right: 10px;
  outline: none;
`;

export const FavButtons = styled.div`
  cursor: pointer;
`;
